module.exports = __webpack_public_path__ + "media/img/alfredapp-ed223f366f5d61a254442a27861ff49b.png";